// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","name_wrapper":"name_wrapper-14r2j","name_withPrices":"name_withPrices-3Ussk","prices":"prices-3ym3q"};